/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleTypeIntervalFromJSON, GoogleTypeIntervalToJSON, StreemApiAggregatedRoomMetricsAggregatedByFromJSON, StreemApiAggregatedRoomMetricsAggregatedByToJSON, StreemApiAggregatedRoomMetricsMetricsFromJSON, StreemApiAggregatedRoomMetricsMetricsToJSON, } from './';
export function StreemApiAggregatedRoomMetricsFromJSON(json) {
    return StreemApiAggregatedRoomMetricsFromJSONTyped(json, false);
}
export function StreemApiAggregatedRoomMetricsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aggregatedBy': !exists(json, 'aggregated_by') ? undefined : StreemApiAggregatedRoomMetricsAggregatedByFromJSON(json['aggregated_by']),
        'metrics': !exists(json, 'metrics') ? undefined : StreemApiAggregatedRoomMetricsMetricsFromJSON(json['metrics']),
        'timeRange': !exists(json, 'time_range') ? undefined : GoogleTypeIntervalFromJSON(json['time_range']),
    };
}
export function StreemApiAggregatedRoomMetricsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aggregated_by': StreemApiAggregatedRoomMetricsAggregatedByToJSON(value.aggregatedBy),
        'metrics': StreemApiAggregatedRoomMetricsMetricsToJSON(value.metrics),
        'time_range': GoogleTypeIntervalToJSON(value.timeRange),
    };
}
//# sourceMappingURL=StreemApiAggregatedRoomMetrics.js.map